import { render, staticRenderFns } from "./TenantDetails.vue?vue&type=template&id=cebe95f0&"
import script from "./TenantDetails.vue?vue&type=script&lang=js&"
export * from "./TenantDetails.vue?vue&type=script&lang=js&"
import style0 from "./TenantDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports